import React from 'react';
import { FaRocket, FaGem, FaCrown } from 'react-icons/fa';

const packages = [
  {
    name: 'Starter',
    price: 'Free',
    icon: <FaRocket className="text-gray-200 h-6 w-6" />,
    description: 'Ideal for small clinics and individual practitioners starting their compliance journey.',
    features: [
      'Access to public policy repository',
      'Basic SOP templates',
      'Monthly newsletter',
    ],
    cta: 'Join Free',
  },
  {
    name: 'Professional',
    price: 'KES 5,000/month',
    icon: <FaGem className="text-blue-300 h-6 w-6" />,
    description: 'Designed for hospitals and mid-sized facilities seeking structured governance tools.',
    features: [
      'Full access to hospital management policies',
      'Downloadable SOPs and compliance checklists',
      'Consultation support (2 sessions/month)',
      'Priority email support',
    ],
    cta: 'Subscribe Now',
  },
  {
    name: 'Enterprise',
    price: 'Custom Pricing',
    icon: <FaCrown className="text-yellow-500 h-6 w-6" />,
    description: 'For regional networks, teaching hospitals, and multi-site organizations.',
    features: [
      'Dedicated account manager',
      'Custom policy integration',
      'Staff training modules',
      'Advanced analytics and reporting',
      'On-site consultation options',
    ],
    cta: 'Request Demo',
  },
];

const SubscriptionComponent = () => {
  return (
    <div className="p-6 bg-gray-100">
      <h2 className="text-4xl font-bold text-center text-blue-900 mb-10">
        Subscription Packages
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {packages.map((pkg, index) => (
          <div
            key={index}
            style={{ borderRadius: "32px" }}
            className="bg-blue-800 shadow-lg p-6 flex flex-col justify-between hover:shadow-lg transition"
          >
            <div>
              <h3  className="text-2xl flex items-center font-bold text-blue-50 mb-2">
                {pkg.icon}
                <span className='ml-4'>{pkg.name}</span>               
              </h3>
              <span className='block mb-2' style={{ borderBottom: "1px solid #caf1de38" }}></span>
              <p className="text-lg font-semibold text-green-300 mb-4">{pkg.price}</p>
              <p className="text-gray-200 mb-4">{pkg.description}</p>
              <ul className="list-disc list-inside text-gray-100 space-y-2 mb-6">
                {pkg.features.map((feature, i) => (
                  <li key={i}>{feature}</li>
                ))}
              </ul>
            </div>
            <button className="mt-auto px-4 py-2 bg-green-600 font-semibold text-white rounded-lg hover:bg-blue-700 transition">
              {pkg.cta}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SubscriptionComponent;
